import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"

const Products = () => (
    <Layout>
        <h1>Welcome to Apple</h1>
        <StaticImage
            src="../images/shutterstock_1362710882.png"
            width={300}
            quality={95}
            formats={["auto", "webp", "avif"]}
            alt="iPhone Planet"
            style={{ marginBottom: `1.45rem` }}
        />
        <Seo title="Page two" />
        <h1>The ultimate iPhone</h1>
        <p>The future is here. Join the iPhone Upgrade Program to get the latest iPhone - NOW!</p>
        <Link to="/">Home</Link>
    </Layout>
)

export default Products
